import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';

import { IHouseStats } from '../../../../types/newbuilding/genplan';
import { Link } from '../../../Link';

import * as styles from './styles.css';

interface IHouseStatsProps extends IHouseStats {
  houseId: number;
  onLinkClick(houseId: number, rooms?: string): void;
}

export function HouseStats({
  houseId,
  fromDeveloperPropsCountUrl,
  fromDeveloperPropsCountDisplay,
  fromDeveloperRooms,
  onLinkClick,
}: IHouseStatsProps) {
  return (
    <>
      {fromDeveloperRooms.map(({ roomTypeDisplay, price2From, offersUrl, roomType }) => (
        <Link
          key={roomTypeDisplay}
          url={offersUrl}
          target="blank"
          linkStyle={styles['room-link']}
          onClick={() => onLinkClick(houseId, roomType)}
        >
          <InlineText2>
            <b>{roomTypeDisplay}</b> {price2From}
          </InlineText2>
        </Link>
      ))}
      <Link
        url={fromDeveloperPropsCountUrl}
        target="blank"
        linkStyle={styles['link']}
        onClick={() => onLinkClick(houseId)}
      >
        <InlineText2 color="primary_100">{fromDeveloperPropsCountDisplay}</InlineText2>
      </Link>
    </>
  );
}
